import React, {useEffect, useRef, useState} from "react";
import {
    IonButton, IonCheckbox,
    IonContent, IonDatetime,
    IonHeader, IonItem, IonLabel,
    IonPage,
    IonTitle, IonToolbar
} from "@ionic/react";
import {AcaGetPipelineStagesResponseStage} from "../types";
import moment from "moment";

const ModalMoreDetails = ({dismiss, pipelineStage}: { dismiss: (data?: {
        verificationDate: Date | null | undefined,
        verificationDataRequested: number[]
    }, role?: string) => void, pipelineStage: AcaGetPipelineStagesResponseStage}) => {
    const [datetime, setDatetime] = useState<Date | null | undefined>(null);
    const [dataItems, setDataItems] = useState<number[]>([]);
    const modal = useRef<HTMLIonModalElement>(null);

    const updateDataRequested = async (field: number | undefined | null, value: boolean) => {
        if (field) {
            let tmpItems: number[] = dataItems;
            if (value) {
                // adding
                tmpItems.push(field);
            } else {
                // removing
                tmpItems = tmpItems.filter((item) =>item !== field);
            }
            setDataItems(tmpItems);
        }

    };


    useEffect(() => {
        const date = new Date();

        // Set the value of the datetime to the day
        // calculated above
        date.setMonth(date.getMonth() + 1);
        setDatetime(date);
    }, []);

    return (
        <IonPage ref={modal}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>More Details Needed For Enrolled Pending Verification</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">

                <p>Please specify the date by which you would like the opportunity verified and which documents may be needed.</p>


                <IonDatetime presentation="date" value={moment(datetime).format("YYYY-MM-DD HH:mm:ss")} onIonChange={(e) => setDatetime(e.detail.value ? new Date(e.detail.value.toString()) : null)} ></IonDatetime>

                {pipelineStage && pipelineStage.documentsRequested && pipelineStage.documentsRequested.length > 0 &&
                    <>
                        <p>Select the documents requested:</p>
                        {pipelineStage.documentsRequested && pipelineStage.documentsRequested.map((item, index) => {
                            return (
                                <IonItem>
                                    <IonCheckbox key={'doc_'+index} justify="space-between" onClick={(e) => updateDataRequested(item.id, e.currentTarget.checked)}>{item.name}</IonCheckbox>
                                </IonItem>
                            );
                        })}
                    </>
                }



                <p style={{textAlign: 'right'}}>
                    <IonButton onClick={() => dismiss(undefined, 'cancel')} fill="outline">Cancel</IonButton>
                    <IonButton strong={true} onClick={() => dismiss({verificationDate: datetime, verificationDataRequested: dataItems.map((item) => item)}, 'confirm')}>
                        Confirm
                    </IonButton>
                </p>
            </IonContent>
        </IonPage>);
};

export default ModalMoreDetails;